var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 17.615,
  height: 18.78,
  fill: "transparent",
  stroke: "#4264FD",
  strokeWidth: 1.5,
  rx: 1,
  transform: "matrix(.98936 .14551 -.19023 .98174 8.073 4.5)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4264FD",
  strokeWidth: 1.5,
  d: "m6.424 15.218 16.752 1.281m-9.534-10.99-1.568 9.839m6.377.288-2.094 8.715"
})));
export default SvgIconLand;